/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import { Link } from "react-router-dom";
import { ReactComponent as SimpliCityLogo } from "cms/assets/images/SimpliCity-logo.svg";

const Header = () => {

    const contactLink = "mailto:info@simplicitycms.ca?subject=Inquiry%20re%3A%20SimpliCity%20CMS";
    const demoLink = "mailto:info@simplicitycms.ca?subject=Demo%20re%3A%20SimpliCity%20CMS";

    return (
        <div className='header'>
            <div className='header-content'>
                <Link to='/' className='simplicity-logo'>
                    <SimpliCityLogo alt='simplicity-logo' />
                </Link>
                <div className='header-buttons'>
                    <a href={contactLink} className='contact-button'>Contact</a>
                    <a href={demoLink} className='demo-button'>Book a Demo</a>
                </div>
            </div>
        </div>
    );
};

export { Header };
